<widget-pie-chart [dataSource]="pieDataSource" />
